export default __webpack_public_path__ + "static/media/image5.bcf5ac51.png";